import { useLocation } from 'react-router-dom';
import { PortalPageFooter } from '../PortalPageFooter/PortalPageFooter';
import { shouldShowRouteScopedPortalChrome } from '../../utils/routeScopedPortalChrome.utils';

export { shouldShowRouteScopedPortalChrome };

export function RouteScopedPortalFooter() {
  const { pathname } = useLocation();
  if (!shouldShowRouteScopedPortalChrome(pathname)) return null;
  return <PortalPageFooter />;
}
